<div class="images" photoGalleryGroup>
  <div [photoGallery]="imageUrl">
    <div class="images-item image-cropper">
      @if (!!thumbnailUrl?.length) {
        <img class="images-item-image" [src]="thumbnailUrl" [alt]="label" />
      }
      @if (!thumbnailUrl?.length) {
        <img class="images-item-image" [src]="'assets/img/no-image.png'" [alt]="label" />
      }
    </div>
  </div>
  @if (product && product.images && product.images.length > 1) {
    @for (img of restOfProductImages; track img) {
      <div
        [photoGallery]="img.url"
        [photoGalleryCaption]="
          img.product
            ? img.product.fullName +
              '<br>' +
              (img.product.code ? ('product.code' | translate) + img.product.code : '') +
              '<br>' +
              (img.product.ean ? ' EAN: ' + img.product.ean : '')
            : ''
        "
      ></div>
    }
  }
</div>
